import { useParams } from "react-router-dom";
import { DetailPageSections } from "../shared";
import { ServiceDiskAttachmentsList } from "../shared/persistent-disk";

export const AppDetailServiceDiskStoragePage = () => {
  const { serviceId = "" } = useParams();

  return (
    <div className="mb-4">
      <DetailPageSections>
        <ServiceDiskAttachmentsList serviceId={serviceId} />
      </DetailPageSections>
    </div>
  );
};
